<template>
  <div class="empadronamiento__intro__main">
    <div class="empadronamiento__intro__main__form" v-if="!loading">
      <div class="empadronamiento__intro__main__form__header">
        <p>{{ ModelProcedure.UnitFullName }}</p>
      </div>
      <div class="empadronamiento__intro__main__form__container">
        <form @submit.prevent>
          <fieldset>
            <div class="empadronamiento__intro__main__form__container-header">
              <p v-if="ModelProcedure.ProcedureType == 1">
                DATOS – TITULAR PROPIETARIO
                <span v-if="LegalPersonAsociated != null"
                  >- RELACIONADO A({{ LegalPersonAsociated.Name }})</span
                >
              </p>
              <p v-if="ModelProcedure.ProcedureType == 2">
                DATOS – TITULAR CONTRATO DE ALQUILER
                <span v-if="LegalPersonAsociated != null"
                  >- RELACIONADO A({{ LegalPersonAsociated.Name }})</span
                >
              </p>
            </div>

            <p
              class="empadronamiento__form_header_info_text"
              style="text-align: justify;"
            >
              Por favor, completá los datos requeridos con la información del
              titular. Para este paso es necesario contar con foto del
              DNI/Pasaporte (frente y dorso) y Certificado de Reincidencia.
            </p>

            <template
              v-if="ModelProcedure.Titulars[titularIdx].PersonTypeId == 1"
            >
              <base-select
                placeholder="Tipo de persona *"
                v-model="ModelProcedure.Titulars[titularIdx].PersonTypeId"
                :options="Enums.ProcedureTitularPersonType"
                :disabled="true"
              />

              <base-select
                placeholder="Tipo de documento *"
                v-model="
                  ModelProcedure.Titulars[titularIdx].IdentificationTypeId
                "
                :options="Enums.IdentificationType"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx]
                    .IdentificationTypeId.$invalid && submitted
                "
                :disabled="true"
              />

              <base-input
                placeholder="Documento *"
                v-model="ModelProcedure.Titulars[titularIdx].Identification"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Identification
                    .$invalid && submitted
                "
                :disabled="true"
              />

              <base-input
                placeholder="Nombre *"
                v-model="ModelProcedure.Titulars[titularIdx].Name"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Name.$invalid &&
                    submitted
                "
              />

              <base-input
                placeholder="Apellido *"
                v-model="ModelProcedure.Titulars[titularIdx].LastName"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].LastName
                    .$invalid && submitted
                "
              />

              <base-date-picker
                v-model="ModelProcedure.Titulars[titularIdx].BirthDay"
                :maxDate="BirthDayMaxDate"
                :label="'Fecha de nacimiento *'"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].BirthDay
                    .$invalid && submitted
                "
              />

              <base-select
                placeholder="Nacionalidad *"
                v-model="ModelProcedure.Titulars[titularIdx].NationalityId"
                :options="Nationalities"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].NationalityId
                    .$invalid && submitted
                "
              />

              <div class="empadronamiento__intro__main__form__container-tittle">
                <p>Estado civil</p>
                <div
                  class="demo"
                  v-for="(marital,
                  idx) in Enums.ProcedureTitularMaritalStatusType"
                  :key="idx"
                >
                  <input
                    type="radio"
                    :value="marital.Id"
                    v-model="
                      ModelProcedure.Titulars[titularIdx].MaritalStatusId
                    "
                  />
                  <label>{{ marital.Name }}</label>
                </div>
                <small
                  v-if="
                    $v.ModelProcedure.Titulars.$each[titularIdx].MaritalStatusId
                      .$invalid && submitted
                  "
                  style="color: red;"
                  >Seleccione un estado civil</small
                >
              </div>
              <div v-if="!hideAttachments">
                <template v-for="(attach, i) in TitularAttachmentTypes">
                  <base-file-upload
                    :key="i"
                    :keyIndex="i"
                    :attach="attach"
                    :showTooltipActive="showTooltipActive"
                    @changeTooltipActive="showTooltipActive = $event"
                    @change="uploadFile"
                    @clearUpload="clearFile"
                    :modelProp="getAttachModelPropName(attach)"
                    :state="
                      ModelProcedure.Titulars[titularIdx][
                        getAttachModelPropName(attach)
                      ]
                    "
                    :invalid="getAttachValidator(attach).$invalid && submitted"
                    :previewURL="getAttachPreviewURL(attach)"
                  />

                  <p
                    :key="'p1' + i.toString()"
                    v-if="attach.Code === 'ProcedureTitularAttachment.RNR'"
                    class="empadronamiento__intro__main__form__container__notes"
                  >
                    El certificado adjunto debe tener fecha de expedición menor
                    a 90 días desde el comienzo del trámite de empadronamiento.
                  </p>

                  <p
                    :key="'p2' + i.toString()"
                    v-if="
                      attach.Code === 'ProcedureTitularAttachment.IdResidence'
                    "
                    class="empadronamiento__intro__main__form__container__notes"
                  >
                    La visa precaria es requisito excluyente para todo
                    extranjero que permanezca por más de 90 días en el país. En
                    caso de permanecer en carácter de turista, se debe adjuntar
                    certificado de migraciones emitido al ingresar al país, el
                    mismo puede descargarse en el siguiente link:
                    <a
                      href="https://www.migraciones.gov.ar/transitos/"
                      target="_blank"
                      rel="noreferrer noopener"
                      >Tránsitos | DNM</a
                    >
                  </p>
                </template>
              </div>
              <base-input
                type="email"
                :placeholder="
                  ModelProcedure.ProcedureType === 1
                    ? 'Mail del nuevo propietario *'
                    : 'Mail del nuevo locatario *'
                "
                v-model="ModelProcedure.Titulars[titularIdx].Email"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Email.$invalid &&
                    submitted
                "
                :disabled="true"
              />

              <base-input
                type="tel"
                placeholder="Teléfono de contacto *"
                v-model="ModelProcedure.Titulars[titularIdx].Phone"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Phone.$invalid &&
                    submitted
                "
                :disabled="true"
              />

              <div class="empadronamiento__intro__main__form__container-tittle">
                <p style="text-transform: uppercase;">
                  ¿Será residente de la unidad?
                </p>
                <div class="demo">
                  <input
                    type="radio"
                    :value="true"
                    v-model="ModelProcedure.Titulars[titularIdx].IsUnitResident"
                  />
                  <label>SI</label>
                </div>
                <div class="demo">
                  <input
                    type="radio"
                    :value="false"
                    v-model="ModelProcedure.Titulars[titularIdx].IsUnitResident"
                  />
                  <label>NO</label>
                </div>
              </div>
            </template>

            <template
              v-if="ModelProcedure.Titulars[titularIdx].PersonTypeId == 2"
            >
              <base-select
                placeholder="Tipo de persona *"
                v-model="ModelProcedure.Titulars[titularIdx].PersonTypeId"
                :options="Enums.ProcedureTitularPersonType"
                :disabled="true"
              />

              <base-input
                placeholder="CUIT *"
                v-model="ModelProcedure.Titulars[titularIdx].CUIL"
                :invalid="false"
                :disabled="true"
              />

              <base-input
                placeholder="Razón Social *"
                v-model="ModelProcedure.Titulars[titularIdx].Name"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Name.$invalid &&
                    submitted
                "
              />

              <base-input
                placeholder="Nombre Fantasía *"
                v-model="ModelProcedure.Titulars[titularIdx].LastName"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].LastName
                    .$invalid && submitted
                "
              />
              <div
                v-for="(attach, i) in TitularAttachmentTypes"
                :key="attach.Id"
              >
                <base-file-upload
                  :keyIndex="i"
                  :attach="attach"
                  :showTooltipActive="showTooltipActive"
                  @changeTooltipActive="showTooltipActive = $event"
                  @change="uploadFile"
                  @clearUpload="clearFile"
                  :modelProp="getAttachModelPropName(attach)"
                  :state="
                    ModelProcedure.Titulars[titularIdx][
                      getAttachModelPropName(attach)
                    ]
                  "
                  :invalid="getAttachValidator(attach).$invalid && submitted"
                  :previewURL="getAttachPreviewURL(attach)"
                />
              </div>

              <div class="empadronamiento__intro__main__form__container-header">
                <p>Máximo Beneficiario</p>
              </div>

              <div v-if="firstBeneficiary">
                <base-input
                  placeholder="Nombre *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].Beneficiaries[0].Name
                  "
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .Beneficiaries[0].Name.$invalid && submitted
                  "
                />

                <base-input
                  placeholder="Apellido *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].Beneficiaries[0]
                      .LastName
                  "
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .Beneficiaries[0].LastName.$invalid && submitted
                  "
                />
                <base-select
                  placeholder="Tipo de documento *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].Beneficiaries[0]
                      .IdentificationTypeId
                  "
                  :options="Enums.IdentificationType"
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .Beneficiaries[0].IdentificationTypeId.$invalid &&
                      submitted
                  "
                  :disabled="true"
                />

                <base-input
                  placeholder="Documento *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].Beneficiaries[0]
                      .Identification
                  "
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .Beneficiaries[0].Identification.$invalid && submitted
                  "
                />
              </div>
              <div v-if="firstBeneficiary">
                <div
                  v-for="(attach, i) in BeneficiaryAttachmentTypes"
                  :key="attach.Id"
                >
                  <base-file-upload
                    :keyIndex="i"
                    :attach="attach"
                    :showTooltipActive="showTooltipActive"
                    @changeTooltipActive="showTooltipActive = $event"
                    @change="uploadBeneficiaryFile"
                    @clearUpload="clearBeneficiaryFile"
                    :modelProp="getBeneficiaryAttachModelPropName(attach)"
                    :state="
                      firstBeneficiary[
                        getBeneficiaryAttachModelPropName(attach)
                      ]
                    "
                    :invalid="submitted && isBeneficiaryAttachInvalid(attach)"
                    :previewURL="getBeneficiaryAttachPreviewURL(attach)"
                  />
                </div>
                <div
                  v-for="attach in BeneficiaryAttachmentTypes"
                  :key="'note-' + attach.Id"
                >
                  <p
                    v-if="attach.Code === 'ProcedureBeneficiaryAttachment.RNR'"
                    class="empadronamiento__intro__main__form__container__notes"
                  >
                    El certificado adjunto debe tener fecha de expedición menor
                    a 90 días.
                  </p>
                </div>
              </div>

              <base-input
                type="email"
                placeholder="Email *"
                v-model="ModelProcedure.Titulars[titularIdx].Email"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Email.$invalid &&
                    submitted
                "
                :disabled="true"
              />

              <base-input
                type="tel"
                placeholder="Teléfono de contacto *"
                v-model="ModelProcedure.Titulars[titularIdx].Phone"
                :invalid="
                  $v.ModelProcedure.Titulars.$each[titularIdx].Phone.$invalid &&
                    submitted
                "
                :disabled="true"
              />
              <fieldset>
                <div
                  class="empadronamiento__intro__main__form__container-header"
                >
                  <p>Domicilio legal</p>
                </div>

                <base-input
                  placeholder="Calle *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].FormerAddresStreet
                  "
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .FormerAddresStreet.$invalid && submitted
                  "
                />

                <base-input
                  type="number"
                  placeholder="Numero *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].FormerAddresNumber
                  "
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .FormerAddresNumber.$invalid && submitted
                  "
                />

                <base-input
                  placeholder="Código Postal *"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].FormerAddresPostCode
                  "
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .FormerAddresPostCode.$invalid && submitted
                  "
                />

                <base-input
                  placeholder="Piso - Opcional"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].FormerAddresFloor
                  "
                />

                <base-input
                  placeholder="Departamento - Opcional"
                  v-model="
                    ModelProcedure.Titulars[titularIdx].FormerAddresDepartment
                  "
                />

                <base-input
                  placeholder="Localidad *"
                  v-model="ModelProcedure.Titulars[titularIdx].FormerAddresCity"
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .FormerAddresCity.$invalid && submitted
                  "
                />

                <base-select
                  v-model="
                    ModelProcedure.Titulars[titularIdx].FormerAddresStateId
                  "
                  placeholder="Provincia *"
                  :options="ListStates"
                  :invalid="
                    $v.ModelProcedure.Titulars.$each[titularIdx]
                      .FormerAddresStateId.$invalid && submitted
                  "
                />
              </fieldset>
            </template>
          </fieldset>
        </form>

        <div class="empadronamiento__intro__button">
          <button-link back @back="onBack">
            <p>Volver</p>
          </button-link>
          <button v-if="!loadingForm" class="active" @click="updateTitular()">
            Continuar
          </button>
          <button v-else disabled>Procesando ...</button>
        </div>
      </div>
    </div>
    <div
      v-if="showTooltipActive != ''"
      class="tooltip-background"
      @click="showTooltipActive = ''"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { required, email, not } from "vuelidate/lib/validators";
import moment from "moment";

export default {
  data() {
    return {
      loading: true,
      titularIdx: 0,
      submitted: false,
      section: "TITULAR",
      loadingForm: false,
      showTooltipActive: "",
    };
  },
  mounted() {
    const self = this;
    if (!this.ModelProcedure.hasOwnProperty("UCode")) {
      this.$store
        .dispatch("getProcedure", {
          ucode: this.$route.query.ucode,
        })
        .then(() => {
          self.$store.dispatch("getEnums");
          self.$store.dispatch("getNationalities");
          self.$store.dispatch("getAllNeighborhoods");
          self.$store.dispatch("getSelectedCountryStates", 1);
          this.titularIdx = Number(this.$route.params.indexTitular);
          this.ensureLegalDefaults();
          self.loading = false;
        });
    } else {
      self.$store.dispatch("getEnums");
      self.$store.dispatch("getNationalities");
      self.$store.dispatch("getAllNeighborhoods");
      self.$store.dispatch("getSelectedCountryStates", 1);
      this.titularIdx = Number(this.$route.params.indexTitular);
      this.ensureLegalDefaults();
      self.loading = false;
    }
    /* const titulars = this.ModelProcedure && this.ModelProcedure.Titulars;
    const t = titulars && titulars[this.titularIdx];

    if (t && t.PersonTypeId === 2) {
      if (!Array.isArray(t.Beneficiaries)) {
        this.$set(t, "Beneficiaries", []);
      }
      if (!t.Beneficiaries[0]) {
        t.Beneficiaries.push({
          Id: 0,
          Name: "",
          LastName: "",
          IdentificationTypeId: 1,
          Identification: "",
          IdFront: 0,
          IdBack: 0,
          RNR: 0,
        });
      }
    }
    const tit = this.ModelProcedure && this.ModelProcedure.Titulars;
    const s = tit && tit[this.titularIdx];
    if (!s) return;

    if (s.PersonTypeId === 1 && (s.IdentificationTypeId == null)) {
      this.$set(s, "IdentificationTypeId", 1);
    }

    if (Number(s.PersonTypeId) === 2) {
      if (!Array.isArray(t.Beneficiaries)) this.$set(s, "Beneficiaries", []);
      if (!s.Beneficiaries[0]) {
        this.$set(s.Beneficiaries, 0, {
          Id: 0,
          Name: "",
          LastName: "",
          IdentificationTypeId: 1,
          Identification: "",
          IdFront: 0,
          IdBack: 0,
          RNR: 0,
        });
      }
      
      if (typeof t.Statute === "undefined") this.$set(s, "Statute", 0);
    } */
    const tit = this.ModelProcedure && this.ModelProcedure.Titulars;
    const s = tit && tit[this.titularIdx];
    if (!s) return;

    if (s.PersonTypeId === 1 && s.IdentificationTypeId == null) {
      this.$set(s, "IdentificationTypeId", 1);
    }
  },
  computed: {
    ...mapState({
      Enums: (state) => state.neighregistration.Enums,
      AllNeighborhoods: (state) => state.unit.AllNeighborhoods,
      Nationalities: (state) => state.common.Nationalities,
      ListStates: (state) => state.common.ListStates,
      ModelProcedure: (state) => state.manageVecino.ModelProcedure,
    }),

    BirthDayMaxDate() {
      return moment().format("DD/MM/YYYY");
    },

    TitularAttachmentTypes() {
      const all = (this.Enums && this.Enums.ProcedureTitularAttachType) || [];

      // si no hay FR, sacamos ese attach
      let lista = all.slice();
      if (!this.ModelProcedure.FacialRecognition) {
        lista = lista.filter(
          (a) => a.Code !== "ProcedureTitularAttachment.IdFacialRecognition"
        );
      }

      const titulars = this.ModelProcedure && this.ModelProcedure.Titulars;
      const t = titulars && titulars[this.titularIdx];
      if (!t) return [];

      const isStatute = (a) =>
        a.Code === "ProcedureTitularAttachment.Statute" ||
        a.Code === "ProcedureTitularAttachment.LegalStatute";

      if (Number(t.PersonTypeId) === 1) {
        // Persona física: NO mostrar Estatuto
        if (t.RelatedLegalTitular != null) {
          return lista.filter((a) => !isStatute(a));
        }
        return lista.filter(
          (a) =>
            a.Code !== "ProcedureTitularAttachment.ProxyCertificate" &&
            !isStatute(a)
        );
      }

      if (Number(t.PersonTypeId) === 2) {
        // Persona jurídica: SOLO Estatuto
        return lista.filter(isStatute);
      }

      return [];
    },
    LegalPersonAsociated() {
      const mp = this.ModelProcedure;
      const titulars = mp && mp.Titulars;
      const row = titulars && titulars[this.titularIdx];
      if (!row) return null;

      const rel = row.RelatedLegalTitular;
      if (rel != null) {
        const related = titulars.filter((tr) => tr.UniqueCode == rel);
        return related.length > 0 ? related[0] : null;
      }
      return null;
    },
    hideAttachments() {
      const titulars = this.ModelProcedure && this.ModelProcedure.Titulars;
      const row = titulars && titulars[this.titularIdx];
      return !!(row && row.IsResident === true);
    },

    BeneficiaryAttachmentTypes() {
      return (this.Enums && this.Enums.ProcedureBeneficiaryAttachType) || [];
    },

    firstBeneficiary() {
      const titulars = this.ModelProcedure && this.ModelProcedure.Titulars;
      const t = titulars && titulars[this.titularIdx];
      return t && Array.isArray(t.Beneficiaries) ? t.Beneficiaries[0] : null;
    },
  },
  methods: {
    onBack() {
      this.titularIdx = this.titularIdx - 1;
    },
    getAttachPreviewURL(attach) {
      let attachId = null;
      attachId = this.ModelProcedure.Titulars[this.titularIdx][
        this.getAttachModelPropName(attach)
      ];

      let attachUrl = "";

      if (attachId != null && attachId > 0) {
        attachUrl = `${
          process.env.VUE_APP_URL_API
        }/neighregistration/proceduretitularattachment/preview/${attachId}`;
      }

      return attachUrl;
    },

    ensureLegalDefaults() {
      if (
        !this.ModelProcedure ||
        !this.ModelProcedure.Titulars ||
        !this.ModelProcedure.Titulars[this.titularIdx]
      ) {
        return;
      }

      var row = this.ModelProcedure.Titulars[this.titularIdx];

      if (Number(row.PersonTypeId) === 2) {
        if (!Array.isArray(row.Beneficiaries)) {
          this.$set(row, "Beneficiaries", []);
        }
        if (!row.Beneficiaries[0]) {
          this.$set(row.Beneficiaries, 0, {
            Id: 0,
            Name: "",
            LastName: "",
            IdentificationTypeId: 1,
            Identification: "",
            IdFront: 0,
            IdBack: 0,
            RNR: 0,
          });
        }
        if (typeof row.Statute === "undefined") {
          this.$set(row, "Statute", 0);
        }
      }
    },

    updateTitular() {
      const self = this;
      self.submitted = true;
      if (this.$v && this.$v.$touch) this.$v.$touch();

      if (!this.isInvalidForm()) {
        const row = self.ModelProcedure.Titulars[self.titularIdx];
        const ucode = self.$route.query.ucode;

        if (row.IdFacialRecognition !== 0) {
          self.ModelProcedure.HasFacialRecognitionFile = true;
          self.ModelProcedure.TitularIdentificationTypeId =
            row.IdentificationTypeId || null;
          self.ModelProcedure.TitularIdentification = row.Identification || "";
        }

        self.loadingForm = true;
        self.$store
          .dispatch("updateProcedure", { model: self.ModelProcedure })
          .then(() => {
            self.loading = false;

            if (row.PersonTypeId === 1) {
              if (!row.IsResident) {
                self.$router.push(
                  `/vecino/domicilioAnterior/${self.titularIdx}?ucode=${ucode}`
                );
                return;
              }

              const isLast =
                self.titularIdx === self.ModelProcedure.Titulars.length - 1;
              if (!isLast) {
                self.$router.push(
                  `/vecino/titularPropietario/${self.titularIdx +
                    1}?ucode=${ucode}`
                );
                self.titularIdx++;
                self.submitted = false;
                self.loadingForm = false;
                return;
              }

              self.$router.push(`/vecino/conyugePareja?ucode=${ucode}`);
              return;
            }

            // ===== Persona jurídica =====
            const isLast =
              self.titularIdx === self.ModelProcedure.Titulars.length - 1;
            if (isLast) {
              if (self.ModelProcedure.HasPhysicalTitulars) {
                self.$router.push(`/vecino/conyugePareja?ucode=${ucode}`);
              } else {
                self.$router.push(`/vecino/referencia?ucode=${ucode}`);
              }
            } else {
              self.$router.push(
                `/vecino/titularPropietario/${self.titularIdx +
                  1}?ucode=${ucode}`
              );
              self.titularIdx++;
              self.submitted = false;
              self.loadingForm = false;
            }
          });
      } else {
        const el = document.querySelector(
          ".empadronamiento__intro__main__form__container-item .has-error"
        );
        if (el) el.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    },

    getAttachModelPropName({ Name }) {
      return this.$store.getters.findAttachPropByName(Name, this.section);
    },

    getAttachValidator(attach) {
      const propName = this.getAttachModelPropName(attach);
      return this.$v.ModelProcedure.Titulars.$each[this.titularIdx][propName];
    },

    getBeneficiaryAttachModelPropName(attach) {
      switch (attach.Code) {
        case "ProcedureBeneficiaryAttachment.IdFront":
          return "IdFront";
        case "ProcedureBeneficiaryAttachment.IdBack":
          return "IdBack";
        case "ProcedureBeneficiaryAttachment.RNR":
          return "RNR";
        default:
          return "";
      }
    },
    getBeneficiaryAttachPreviewURL(attach) {
      const b = this.firstBeneficiary;
      if (!b) return "";
      const prop = this.getBeneficiaryAttachModelPropName(attach);
      const id = b[prop];
      return id && id > 0
        ? `${
            process.env.VUE_APP_URL_API
          }/neighregistration/procedurebeneficiaryattachment/preview/${id}`
        : "";
    },

    isBeneficiaryAttachInvalid(attach) {
      const v = this.$v;
      const vRow =
        v &&
        v.ModelProcedure &&
        v.ModelProcedure.Titulars &&
        v.ModelProcedure.Titulars.$each &&
        v.ModelProcedure.Titulars.$each[this.titularIdx];

      if (!vRow || !attach) return false;

      const prop = this.getBeneficiaryAttachModelPropName(attach);
      if (!prop) return false;

      const vBenEach =
        vRow.Beneficiaries &&
        vRow.Beneficiaries.$each &&
        vRow.Beneficiaries.$each[0];
      if (
        vBenEach &&
        vBenEach[prop] &&
        typeof vBenEach[prop].$invalid !== "undefined"
      ) {
        return !!vBenEach[prop].$invalid;
      }

      const vBenIdx = vRow.Beneficiaries && vRow.Beneficiaries[0];
      if (
        vBenIdx &&
        vBenIdx[prop] &&
        typeof vBenIdx[prop].$invalid !== "undefined"
      ) {
        return !!vBenIdx[prop].$invalid;
      }

      return false;
    },

    uploadBeneficiaryFile({ file, attachmentTypeId, modelProp }) {
      const b = this.firstBeneficiary;
      if (!b) return;

      this.$store
        .dispatch("uploadFile", {
          file,
          attachmentTypeId,
          section: "BENEFICIARY",
        })
        .then((res) => {
          if (!(modelProp in b)) {
            this.$set(b, modelProp, res);
          } else {
            b[modelProp] = res;
          }
        });
    },

    uploadFile({ file, attach, attachmentTypeId, modelProp }) {
      const self = this;
      const section = self.section;

      if (attach.Code == "ProcedureTitularAttachment.IdFacialRecognition") {
        // Validar extensión
        const validExtensions = ["jpg", "jpeg", "png"];
        const fileExtension = file.name
          .split(".")
          .pop()
          .toLowerCase();
        if (!validExtensions.includes(fileExtension)) {
          window.mainApp.$store.dispatch(
            "addNotification",
            "Formato no permitido. Las extensiones permitidas son: jpg, jpeg, png."
          );
          return;
        }

        // Validar peso (máximo 10MB)
        const maxFileSize = 10 * 1024 * 1024; // 10 MB en bytes
        if (file.size > maxFileSize) {
          window.mainApp.$store.dispatch(
            "addNotification",
            "El archivo es demasiado pesado. EluploadBen peso máximo permitido es 10MB."
          );
          return;
        }

        // Validar dimensiones (mínimo 250x250)
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const img = new Image();
          img.src = event.target.result;
          img.onload = () => {
            const { width, height } = img;
            if (width < 250 || height < 250) {
              window.mainApp.$store.dispatch(
                "addNotification",
                "La imagen debe tener un tamaño mínimo de 250 x 250px."
              );
              return;
            }

            this.$store
              .dispatch("uploadFile", { file, attachmentTypeId, section })
              .then((res) => {
                self.ModelProcedure.Titulars[self.titularIdx][modelProp] = res;
                this.ModelProcedure.HasFacialRecognitionFile = true;
              });

            self.getAttachValidator(attach, self.section).$touch();
          };
        };
      } else {
        this.$store
          .dispatch("uploadFile", { file, attachmentTypeId, section })
          .then((res) => {
            self.ModelProcedure.Titulars[self.titularIdx][modelProp] = res;
            this.isPhotoValid = true;
          });

        self.getAttachValidator(attach, self.section).$touch();
      }
    },

    clearFile({ modelProp }) {
      const self = this;
      self.ModelProcedure.Titulars[self.titularIdx][modelProp] = 0;
    },
    clearBeneficiaryFile({ modelProp }) {
      const self = this;
      self.ModelProcedure.Titulars[this.titularIdx].Beneficiaries[0][
        modelProp
      ] = 0;
    },

   isInvalidForm() {
      const row = this.ModelProcedure.Titulars[this.titularIdx];
      const v = this.$v.ModelProcedure.Titulars.$each[this.titularIdx];

      const isPF = Number(row.PersonTypeId) === 1;
      const needAttachments = isPF && row.IsResident === false;

      if (isPF) {
        return (
          v.Name.$invalid ||
          v.LastName.$invalid ||
          v.BirthDay.$invalid ||
          v.MaritalStatusId.$invalid ||
          v.NationalityId.$invalid ||
          v.IdentificationTypeId.$invalid ||
          v.Identification.$invalid ||
          v.Email.$invalid ||
          v.Phone.$invalid ||
          // adjuntos SOLO si no está empadronado
          (needAttachments && (
            v.IdBack.$invalid ||
            v.IdFront.$invalid ||
            v.RNR.$invalid ||
            (this.ModelProcedure.FacialRecognition && v.IdFacialRecognition.$invalid)
          ))
        );
      }
      return (
        v.Name.$invalid ||
        v.LastName.$invalid ||
        v.FormerAddresStreet.$invalid ||
        v.FormerAddresNumber.$invalid ||
        v.FormerAddresPostCode.$invalid ||
        v.FormerAddresCity.$invalid ||
        v.FormerAddresStateId.$invalid ||
        v.Email.$invalid ||
        v.Phone.$invalid ||
        v.Beneficiaries[0].Name.$invalid ||
        v.Beneficiaries[0].LastName.$invalid ||
        v.Beneficiaries[0].Identification.$invalid ||
        v.Beneficiaries[0].IdFront.$invalid ||
        v.Beneficiaries[0].IdBack.$invalid ||
        v.Beneficiaries[0].RNR.$invalid ||
        v.Identification.$invalid
      );
    }
  },
  validations() {
    if (this.ModelProcedure.Titulars[this.titularIdx].PersonTypeId === 1) {
      return {
        ModelProcedure: {
          Titulars: {
            $each: {
              Name: {
                required,
              },
              LastName: {
                required,
              },
              BirthDay: {
                required,
                notFuture: (v) => {
                  const m = moment(v, "DD/MM/YYYY", true);
                  return m.isValid() && m.isSameOrBefore(moment(), "day");
                },
                minAge18: (v) => {
                  const m = moment(v, "DD/MM/YYYY", true);
                  return m.isValid() && moment().diff(m, "years") >= 18;
                },
              },
              MaritalStatusId: {
                required,
                not: not((model) => model === 0),
              },
              NationalityId: {
                required,
                not: not((model) => model === 0),
              },
              IdentificationTypeId: {
                required,
                not: not((model) => model === 0),
              },
              Identification: {
                required,
              },
              CUIL: {
                required,
              },
              Email: {
                required,
                email,
              },
              Phone: {
                required,
              },
              IdBack: {
                required,
                not: not((model) => model === 0),
              },
              IdFront: {
                required,
                not: not((model) => model === 0),
              },
              RNR: {
                required,
                not: not((model) => model === 0),
              },
              ProxyCertificate: {
                not: not((model) => model === 0),
              },
              IdResidence: {},
              IdFacialRecognition: {
                required,
                not: not((model) => model === 0),
              },
            },
          },
        },
      };
    } else {
      return {
        ModelProcedure: {
          Titulars: {
            $each: {
              Beneficiaries: {
                0: {
                  Name: { required },
                  LastName: { required },
                  Identification: { required },
                  IdentificationTypeId: { required, not: not((v) => v === 0) },
                  IdFront: { required, not: not((v) => v === 0) },
                  IdBack: { required, not: not((v) => v === 0) },
                  RNR: { required, not: not((v) => v === 0) },
                },
              },
              Name: {
                required,
              },
              LastName: {
                required,
              },
              Identification: {
                //required
              },

              FormerAddresStreet: {
                required,
              },
              FormerAddresNumber: {
                required,
              },
              FormerAddresPostCode: {
                required,
              },
              FormerAddresCity: {
                required,
              },
              FormerAddresStateId: {
                not: not((model) => model === 0),
                required,
              },
              Email: {
                required,
                email,
              },
              Phone: {
                required,
              },
              Statute: {
                required,
                not: not((model) => model === 0),
              },
            },
          },
        },
      };
    }
  },
};
</script>

<style></style>
